"use strict";
/*jshint esversion: 11 */

import {PivotalApiBase} from "./PivotalApiBase";
import {
  stopLoadingSpinner
} from "../../../components/csf-ufc-pivotal/includes/utils";

export default class PivotalAttachmentsApi extends PivotalApiBase {

  constructor(baseUrl, apiEnv, apiToken) {
    super(baseUrl, apiEnv, apiToken);
  }

  setAccessToken(token) {
    this.apiToken = token;
  }

  static getDownloadAction() {
    return 'download';
  }

  static getNewTabAction() {
    return 'newtab';
  }


  downloadAttachment(requestData, envSplit) {
    const filename = requestData.filename;
    const action = requestData?.action || PivotalAttachmentsApi.getDownloadAction();
    const downloadRequestData = {
      form: requestData.form,
      recordId: requestData.recordId,
      fieldName: requestData.fieldName,
    };
    this.callTaskEndpoint(downloadRequestData, envSplit).then(blob => {
      if (blob) {
        if (action === 'download') {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else if (action === 'newtab') {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.target = '_blank';
          a.href = url;
          a.click();
          document.body.removeChild(a);
        }
      }
    })
      .catch(error => {
        console.error(error);
      });
  }

  callTaskEndpoint(requestData, envSplit) {
    return this._fetchAttachmentsRequest('/rest/attachments/forms/actions/retrieve', requestData, envSplit);
  }

  callTaskUploadEndpoint(requestData, envSplit) {
    return this._uploadAttachmentsRequest('/rest/attachments/uploads/actions/uploadBase64', requestData, envSplit);
  }

}
